import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as Sentry from "@sentry/browser";
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {


  initialized = false;


  constructor(@Inject(LOCALE_ID) public locale: string, private oidcSecurityService: OidcSecurityService,
   private router: Router, private config: PrimeNGConfig) {

  }

  ngOnInit(): void {

    if(this.locale == 'it') {
      this.config.setTranslation({
        "dayNamesMin": ["Do","Lu","Ma","Me","Gi","Ve","Sa"],
        "monthNames": ["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],
        //translations
      });
    } else {
      this.config.setTranslation({
        "dayNamesMin": ["Su","Mo","Tu","We","Th","Fr","Sa"],
        "monthNames": ["January","February","March","April","May","June","July","August","September","October","November","December"],
        //translations
      });
    }
  
    this.oidcSecurityService.checkAuthIncludingServer() // checks to see if the current url contains id token and access token
      .subscribe((authorized) => {
        this.initialized = true;
        if (authorized) {
          this.oidcSecurityService.userData$.pipe(take(1)).subscribe(userData => {
            if (environment.production) { //spostarlo fuori dal subscribe. Qui per test
              Sentry.configureScope((scope) => {
                scope.setUser(
                  {
                    id: userData.sub,
                    username: userData.idSocio,
                    email: userData.email
                  }
                );
              });
            }
          });
          this.router.navigate(['/area-utente']);
        } else {

          Sentry.configureScope(scope => scope.clear());
        }
      }, (err) => {
        console.log("err authorized")
        console.log(err);
        alert("Auth problem. Try again later");
      });
  }


}
